/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tb_Integrations_DescInputs */

const en_mk_tb_integrations_desc = /** @type {(inputs: Mk_Tb_Integrations_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link GitHub PRs and required checks. Import and refresh GitLab.com issues with read-only access, reviewing conflicts before applying changes.`)
};

const id_mk_tb_integrations_desc = /** @type {(inputs: Mk_Tb_Integrations_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hubungkan PR GitHub dan pemeriksaan wajib. Impor dan perbarui issue GitLab.com dengan akses baca saja, lalu tinjau konflik sebelum menerapkan perubahan.`)
};

/**
* | output |
* | --- |
* | "Link GitHub PRs and required checks. Import and refresh GitLab.com issues with read-only access, reviewing conflicts before applying changes." |
*
* @param {Mk_Tb_Integrations_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tb_integrations_desc = /** @type {((inputs?: Mk_Tb_Integrations_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tb_Integrations_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tb_integrations_desc(inputs)
	return en_mk_tb_integrations_desc(inputs)
});